import { Link } from "react-router-dom";

export const PostNav = ({ posts }) => {

    return (
        <>
            <div className="d-flex flex-column gap-4 justify-content-between mb-5 w-100" id="post-nav">
                <div className="d-flex">
                    <div className="w-100 row gap-4 align-items-center">
                        {
                            posts.map(
                                ({ slug, title }) => {
                                    return <Link key={slug} to={`/blog/${slug}`} className="post-nav-link col-lg-4 col-11 text-truncate">{title}</Link>
                                }
                            )
                        }
                    </div>
                    <Link className="post-nav-link" to={"/blog"}>
                        <img src='/images/blog/assets/arrow_right.svg' alt="arrow right to blog" width={35} />
                    </Link>
                </div>
                <div className="container mx-auto w-100 px-lg-5">
                    <div className="border border-top border-bottom-0 mb-1 border-blue" />
                </div>
            </div>
        </>
    );
}
